(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("os"), require("child_process"));
	else if(typeof define === 'function' && define.amd)
		define(["os", "child_process"], factory);
	else if(typeof exports === 'object')
		exports["parallel-es"] = factory(require("os"), require("child_process"));
	else
		root["parallel-es"] = factory(root["os"], root["child_process"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_21__, __WEBPACK_EXTERNAL_MODULE_49__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition